import { kea } from "app/main/std";
import React = require("react");

interface ModalProps extends kea.ModalProps<string, boolean, string> {
}


/**
* Modal de observaciones
*/
export class ObservacionesModal extends React.PureComponent<ModalProps> {
    value = (props: ModalProps) => props.value;

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;

        return (
            <kea.Modal
                onClose={this.onCerrar}
                buttons={[
                    <kea.GuardarButton onClick={() => this.props.onClose(true)} />
                ]}
                title={this.props.params}
            >
                <kea.Text 
                    label="Folio de recolección / Observaciones"
                    value={this.props.value}
                    onChange={this.props.onChange}
                />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/list/observaciones.tsx